/* eslint-disable */
import React from "react";

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="720"
      height="240"
      version="1.1"
      viewBox="0 0 84.635 37.365"
    >
      <g fillOpacity="1" transform="translate(-11.802 -15.457)">
        <path
          fill="#f8f8f8"
          strokeWidth="0.177"
          d="M24.627 129.531c-3.761-6.343-10.71-18.056-15.44-26.028A5013.182 5013.182 0 01.417 88.698c-.157-.295 2.02-.31 44.565-.31h44.731v.614c0 .496-2.906 5.53-15.182 26.295-14.338 24.255-15.21 25.682-15.67 25.682-.459 0-1.004-.868-9.103-14.495-4.739-7.973-8.726-14.518-8.861-14.545-.135-.027-.544.256-.908.629l-.663.678 2.301 4.217c1.266 2.32 2.301 4.25 2.301 4.291 0 .04-2.597 4.403-5.77 9.694-5.268 8.78-5.812 9.62-6.232 9.618-.421-.002-1.047-.991-7.3-11.535z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="#f8f8f8"
          strokeWidth="0.177"
          d="M110.662 138.836c-6.474-.693-12.333-3.456-16.802-7.925-3.748-3.748-6.15-8.168-7.278-13.397-.452-2.093-.448-7.911.007-10.034 1.517-7.084 5.681-13.122 11.764-17.056 2.74-1.772 6.453-3.227 10.011-3.924 2.222-.434 7.501-.434 9.723 0 11.128 2.178 19.419 10.17 21.765 20.98.47 2.164.469 7.745-.003 9.988-2.241 10.676-10.588 18.832-21.44 20.95-1.863.364-6.114.593-7.747.418z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="#f8f8f8"
          strokeWidth="0.177"
          d="M142.924 113.225V88.388l14.893.004 14.894.005 4.295 2.269 4.294 2.27 2.866 4.06 2.867 4.06.501 4.582.501 4.582-.632 3.317-.633 3.317-3.29 3.83c-1.81 2.107-3.329 3.927-3.374 4.044-.045.118 1.435 2.869 3.288 6.114 2.722 4.764 3.37 6.027 3.37 6.56v.66h-43.84z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="#f8f8f8"
          strokeWidth="0.177"
          d="M191.392 138.184l-.385-.41V88.389h24.749c13.612 0 24.749.044 24.749.096 0 .053-4.16 5.522-9.243 12.154-5.084 6.631-9.304 12.156-9.379 12.276-.087.14 3.09 4.506 8.89 12.213 8.551 11.364 9.025 12.032 9.025 12.73v.736h-48.022z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="#f8f8f8"
          strokeWidth="0.177"
          d="M242.98 113.225V88.388h26.87v49.675h-26.87z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="#f8f8f8"
          strokeWidth="0.177"
          d="M284.376 138.184l-.384-.41V113.322l-.398-.081c-.219-.044-2.57-.197-5.227-.34-2.656-.142-4.852-.286-4.88-.32-.029-.034-.144-4.835-.256-10.668-.113-5.834-.25-11.263-.306-12.065l-.102-1.459h47.054V113.137h-10.076l-.004 1.9c-.006 2.763-.497 22.528-.56 22.578-.053.04-23.384.992-24.11.983-.2-.003-.539-.19-.75-.414z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="#f8f8f8"
          strokeWidth="0.047"
          d="M49.233 33.183c-2.319-3.91-10.32-17.498-10.308-17.509.022-.022 25.724.07 28.744.103 2.218.024 2.77.042 2.75.09-.023.062-8.157 13.985-9.595 16.424-.457.777-.877 1.469-.933 1.538l-.1.127-3.184-5.233c-2.423-3.982-3.212-5.243-3.299-5.274-.087-.032-.183-.01-.403.088-.158.071-.288.148-.288.171 0 .065.214.472.977 1.862.389.707.707 1.323.707 1.37 0 .046-.052.186-.115.311-.166.327-2.798 4.687-3.832 6.348-.249.4-.338.482-.53.484-.031 0-.297-.404-.59-.9z"
        ></path>
        <path
          fill="rgb(4, 60, 138)"
          strokeWidth="0.177"
          d="M31.314 140.316c-.24-.315-1.185-1.807-2.103-3.314-1.426-2.344-26.777-45.064-28.131-47.405-.332-.574-.415-.863-.275-.95.112-.068 20.162-.167 44.556-.218 40.976-.087 44.353-.072 44.353.195 0 .47-1.466 3.128-5.962 10.813-11.137 19.033-23.094 39.106-24.2 40.627-.528.727-.659.82-.892.626-.503-.418-1.563-2.13-9.016-14.56-8.215-13.7-8.54-14.223-8.847-14.227-.305-.005-1.464 1.047-1.464 1.329 0 .129 1.004 2.075 2.232 4.325 1.927 3.53 2.208 4.145 2.05 4.49-.301.663-9.14 15.361-10.321 17.167-.604.922-1.199 1.677-1.322 1.677-.122 0-.418-.259-.658-.574z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="rgb(4, 60, 138)"
          strokeWidth="0.177"
          d="M109.778 138.667c-.194-.049-.99-.21-1.767-.357-1.864-.354-5.198-1.471-6.828-2.288-7.237-3.627-12.274-9.84-14.323-17.67-.382-1.46-.416-1.94-.414-5.834.003-3.872.04-4.381.417-5.833 2.18-8.381 7.725-14.887 15.531-18.222 4.037-1.724 7.274-2.305 11.978-2.15 4.08.135 6.947.835 10.64 2.597 7.36 3.512 12.471 9.746 14.574 17.775.382 1.456.417 1.943.414 5.745-.003 4.636-.142 5.52-1.42 8.968-3.16 8.535-10.67 14.91-19.846 16.848-1.27.268-2.593.38-5.155.434-1.896.041-3.606.035-3.8-.014z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="rgb(4, 60, 138)"
          strokeWidth="0.177"
          d="M142.924 113.197V88.33l14.932.109 14.933.108 4.215 2.218 4.215 2.217 2.866 4.06 2.865 4.059.5 4.537.5 4.538-.623 3.292-.624 3.292-3.284 3.863c-2.24 2.636-3.274 3.984-3.255 4.243.028.374.987 2.174 4.38 8.224 1.624 2.898 2.22 4.168 2.22 4.729 0 .204-3.444.243-21.92.243h-21.92z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="rgb(4, 60, 138)"
          strokeWidth="0.177"
          d="M191.482 138.097l-.475-.496V88.388h8.987c4.942 0 16.033.053 24.646.118l15.66.117-1.084 1.43c-1.318 1.738-14.97 19.623-16.436 21.531l-1.048 1.364 1.144 1.641c.63.903 4.401 6 8.382 11.328 7.518 10.062 8.278 11.15 8.47 12.103l.114.573H191.957z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="rgb(4, 60, 138)"
          strokeWidth="0.177"
          d="M242.98 113.225V88.388h26.87v49.675h-26.87z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
        <path
          fill="rgb(4, 60, 138)"
          strokeWidth="0.177"
          d="M284.502 138.107l-.51-.43v-24.54l-.575-.014c-.316-.008-2.643-.147-5.17-.31l-4.597-.295-.12-2.386c-.066-1.313-.208-6.566-.316-11.673-.107-5.108-.242-9.463-.298-9.679l-.102-.392h47.063V113.137h-10.043l-.096 1.635c-.053.9-.184 6.13-.292 11.623-.107 5.494-.237 10.24-.29 10.547l-.095.558-1.796.107c-2.332.138-8.592.399-15.141.63-2.869.102-5.642.211-6.163.243-.795.048-1.03-.012-1.459-.373z"
          transform="matrix(.26458 0 0 .26458 11.802 15.457)"
        ></path>
      </g>
    </svg>
  );
}

export default Logo;
